import { render, staticRenderFns } from "./ControlRamp.vue?vue&type=template&id=294dd01e&scoped=true&"
import script from "./ControlRamp.vue?vue&type=script&lang=js&"
export * from "./ControlRamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294dd01e",
  null
  
)

export default component.exports